import { companyInfo, MainData, menuItem } from "IF/interfaceType";
import React, { createContext, useState, ReactNode, useCallback } from "react";

// 型定義
interface DataContextType {
  detailData: MainData;
  setDetailData: React.Dispatch<React.SetStateAction<MainData>>;
  companyListData: companyInfo[];
  setCompanyListData: React.Dispatch<React.SetStateAction<companyInfo[]>>;
  selectedCompanyCode: string;
  setSelectedCompanyCode: React.Dispatch<React.SetStateAction<string>>;
  menuItems: menuItem[];
  setMenuItems: React.Dispatch<React.SetStateAction<menuItem[]>>;
  choiceMenu: string;
  setChoiceMenu: React.Dispatch<React.SetStateAction<string>>;
  openMenu: string[] | null;
  setOpenMenu: React.Dispatch<React.SetStateAction<string[]>>;
  toggleMenu: (text: string, forceToggle?: boolean) => void;
  isOpen: (key: string) => boolean;
}

// デフォルト値
export const DataContext = createContext<DataContextType | undefined>(
  undefined
);

// Providerコンポーネント
export const DataProvider = ({ children }: { children: ReactNode }) => {
  const [detailData, setDetailData] = useState<MainData>({
    serialNoDataList: [],
    areaNameDataList: [],
  });
  const [companyListData, setCompanyListData] = useState<companyInfo[]>([
    {
      companyCode: "",
      companyName: "",
    },
  ]);

  const [menuItems, setMenuItems] = useState<menuItem[]>([]);

  // メニュー選択を管理
  const [choiceMenu, setChoiceMenu] = useState<string>("");

  // メニューアコーディオンの展開状態を管理
  const [openMenu, setOpenMenu] = useState<string[]>([]);

  const toggleMenu = useCallback(
    (text: string, menuChange: boolean = false) => {
      setOpenMenu((prev) => {
        const exists = prev.includes(text);

        if (menuChange) {
          // 通常のトグル動作（ある→削除、ない→追加）
          return exists ? prev.filter((t) => t !== text) : [...prev, text];
        } else {
          // 強制的に追加（なければ追加、あればそのまま）
          return exists ? prev : [...prev, text];
        }
      });
    },
    []
  );

  const isOpen = (key: string) => openMenu.includes(key);

  // 選択企業コード
  const [selectedCompanyCode, setSelectedCompanyCode] = useState<string>("");

  return (
    <DataContext.Provider
      value={{
        detailData,
        setDetailData,
        companyListData,
        setCompanyListData,
        selectedCompanyCode,
        setSelectedCompanyCode,
        choiceMenu,
        setChoiceMenu,
        menuItems,
        setMenuItems,
        openMenu,
        setOpenMenu,
        toggleMenu,
        isOpen,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};
